// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { DumpsterInventory } from './dumpster-inventory';
import { Job } from './job';

/// <code-import> Place custom imports between <code-import> tags
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DumpsterLocation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  completedBy?: string;
  created!: Date;
  createdBy?: string;
  dumpsterInventoryId!: number;
  placed!: Date;
  placedJobId!: number;
  removed?: Date;
  removedJobId?: number;
  dumpsterInventory!: DumpsterInventory;
  placedJob!: Job;
  removedJob!: Job;
}

